import Vue from 'vue'
import Router from 'vue-router'
import CategoryInstructions from './views/CategoryInstructions.vue'
import BluetoothPairingHelp from './views/help/BluetoothPairing.vue'
import LightFlashingPatterns from './views/help/LightFlashingPatterns.vue'
import QRCodePairingHelp from './views/help/QRCodePairing.vue'
import Home from './views/Home.vue'
import HomeAdvisor from './views/HomeAdvisor.vue'
import InstallationInstructions from './views/InstallationInstructions.vue'
import InstallationIntro from './views/InstallationIntro.vue'
import SendHelpTutorial from './views/SendHelpTutorial.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/:brand/:device/installation-instructions/intro',
      name: 'installationIntro',
      component: InstallationIntro,
      props: true,
    },
    {
      path: '/:brand/:device/installation-instructions/:step',
      name: 'instructions',
      component: InstallationInstructions,
      props: true,
    },
    {
      path: '/:brand/:device/installation-instructions/homeAdvisor',
      name: 'homeAdvisor',
      component: HomeAdvisor,
      props: true,
    },
    {
      path: '/:brand/category/:category/instructions/:step',
      name: 'categoryInstructions',
      component: CategoryInstructions,
      props: true,
    },
    {
      path: '/:brand/help/bluetooth-pairing',
      name: 'bluetoothPairingHelp',
      component: BluetoothPairingHelp,
    },
    {
      path: '/:brand/help/qr-code-pairing',
      name: 'qrCodePairingHelp',
      component: QRCodePairingHelp,
    },
    {
      path: '/:brand/help/light-flashing-patterns',
      name: 'lightFlashingPatterns',
      component: LightFlashingPatterns,
    },
    {
      path: '/send-help-tutorial',
      name: 'sendHelpTutorial',
      component: SendHelpTutorial,
    }
  ],
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
})

router.afterEach(() => {
  setTimeout(() => {
    try {
      window.scrollTo(0, 0)
      const pageContainer = document.getElementById('page-content-container')
      if (pageContainer) {
        pageContainer.scrollTop = 0
      }
    } catch (e) {
      //
    }
  }, 50)
})


export default router;
